import React, { useState, useEffect, useContext } from 'react'
import Button from '../../atoms/Button/Button'
import { Clipboard, Customize } from '../../atoms/NewIcons/index'
import Datatable from '../../atoms/Datatable/Datatable'
import DatatableRowProdotto from '../DatatableRowProdotto/DatatableRowProdotto'
import InfoQuantita from '../../molecules/InfoQuantita/InfoQuantita'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import NewModal from '../../../components/molecules/NewModal/NewModal'
import _ from 'lodash'
import { api } from '../../../utils'
import { CHECKPERSONALIZZAZIONE, PERSONALIZZAZIONICARRELLO } from '../../../utils/endpoint'
import useTrans from '../../../hooks/useTrans'
import FormRadio from '../../atoms/FormRadio/FormRadio'
import { Trans } from '../../../components/atoms'
import { ProdottoContext } from '../../../context/ProdottoContext'
import {
  getIgnoraMinimiStampa,
  showColonnaQuantita,
  showRiepilogo,
} from '../../../utils/servicegift'
import { useSelector } from 'react-redux'
import { trackingGAEventProdotto } from '../../../utils/gtm'

const TableSchedaProdotto = ({
  selectedArticolo,
  selectorTaglia,
  selectorColore,
  prodotto,
  AddToCart,
  showPersonalizzaForm,
  setShowPersonalizzaForm,
  articoliQuantita,
  isValid,
  handleQuantita,
  onChangeInputQuantita,
  disabled,
  service_gift,
  quantita,
  OnClickRichiedi,
  utente,
}) => {
  const t = useTrans()
  const { width } = useWindowDimensions()
  const isAs400Down = useSelector((state) => state.servicegift.as400_down)
  const [totaleArticoli, setTotaleArticoli] = useState(0)
  const [isPersonalizzabile, setIsPersonalizzabile] = useState(false)
  const [personalizzazioniDisponibili, setPersonalizzazioniDisponibili] = useState(null)

  const {
    showDuplicaPersonalizzazione,
    setShowDuplicaPersonalizzazione,
    showQuantitaInsufficiente,
    setShowQuantitaInsufficiente,
    showQuantitaEccessiva,
    setShowQuantitaEccessiva,
    quantitaMassimaPersonalizzabile,
  } = useContext(ProdottoContext)

  const CheckErroreEscluso = (codice_articolo) => {
    const articolo = quantita.filter((articolo) => articolo?.codice === codice_articolo)[0]
    return articolo?.escludi_da_listino_di_stampa && articolo.quantita > 0
      ? {
          error:
            "Questo articolo non può essere personalizzato, rimuovi l'articolo per proseguire con la personalizzazione",
        }
      : null
  }

  const CheckPersonalizzazione = async (prodotto) => {
    const params = {
      prodotto_id: prodotto.id,
    }
    await api.get(CHECKPERSONALIZZAZIONE, { params }).then((response) => {
      response.data && setPersonalizzazioniDisponibili(_.uniqBy(response.data?.pers, 'id'))
      response?.data?.pers?.length > 0
        ? showPersonalizzaForm
          ? null
          : setShowDuplicaPersonalizzazione(true)
        : setShowPersonalizzaForm(true)
    })
  }

  useEffect(() => {
    let mapArticoliQuantita = []
    prodotto.articoli.map((articolo) => {
      mapArticoliQuantita.push({
        id: articolo.id,
        codice: articolo.codice,
        quantita: 0,
      })
    })
  }, [])

  useEffect(() => {
    let mapArticoliQuantita = []
    let quantitaTotale = 0
    prodotto.articoli.map((articolo) => {
      quantitaTotale += articolo.disponibilita ? articolo.disponibilita : 0
      mapArticoliQuantita.push({
        id: articolo.id,
        codice: articolo.codice,
        quantita: 0,
      })
    })
    setTotaleArticoli(quantitaTotale)
    setIsPersonalizzabile(prodotto.personalizzabile)
  }, [prodotto])

  const _handleSubmit = () => {
    AddToCart(articoliQuantita)
  }

  const _withInchiostro =
    prodotto?.articoli
      ?.map((articolo) =>
        articolo?.attributi_lista?.filter((attributo) => attributo?.attributo === 6)
      )
      .filter((result) => result?.length > 0).length > 0
      ? true
      : false

  const n_cols = _.omit(
    prodotto.taglie.length > 0 ? cols : colsMenoTaglia,
    showColonnaQuantita(utente, service_gift) ? [] : ['quantita']
  )

  return (
    <>
      <InfoQuantita
        prodotto={prodotto}
        service_gift={service_gift}
        selectorTaglia={selectorTaglia}
        selectorColore={selectorColore}
        info={{
          acquistabile_multipli: selectedArticolo?.acquistabile_multipli,
          personalizzabile: prodotto?.personalizzabile,
          disponibilita: totaleArticoli,
          disponibilitaRealeMaggiore: prodotto?.articoli.some(
            (a) => a.disponibilita_reale_maggiore
          ),
          quantita_minima_personalizzabile: prodotto?.quantita_minima_personalizzabile,
          imballi: selectedArticolo?.imballi,
          sotto_imballi: selectedArticolo?.sotto_imballi,
          colore: selectedArticolo?.attributi_lista?.filter(
            (attributo) => attributo.attributo === 7
          )[0]?.nome,
          taglia: selectedArticolo?.attributi_lista?.filter(
            (attributo) => attributo.attributo === 8
          )[0]?.nome,
        }}
        articolo={selectedArticolo}
      />

      <Datatable cols={_withInchiostro ? n_cols : _.omit(n_cols, ['inchiostro'])}>
        <div style={{ maxHeight: width < 800 ? 800 : 400 }} className="u-scrollable">
          {prodotto.articoli.map((articolo, i) => (
            <DatatableRowProdotto
              ErroreEscludiListinoDiStampa={CheckErroreEscluso(articolo?.codice)}
              articolo={articolo}
              cols={_withInchiostro ? n_cols : _.omit(n_cols, ['inchiostro'])}
              id={articolo.id}
              key={i}
              index={i}
              inchiostro={
                articolo?.attributi_lista?.filter((attributo) => attributo.attributo === 6)[0]?.nome
              }
              taglia={
                articolo?.attributi_lista?.filter((attributo) => attributo.attributo === 8)[0]?.nome
              }
              colore={
                articolo?.attributi_lista?.filter((attributo) => attributo.attributo === 7)[0]
              }
              isFirstElement={false}
              multipli={articolo.acquistabile_multipli}
              prezzo={
                articolo?.con_fasce && articolo?.fasce[articolo?.fasce.length - 1]?.prezzo
                  ? articolo?.fasce[articolo?.fasce.length - 1].prezzo
                  : articolo.prezzo
              }
              imballi={selectedArticolo?.imballi}
              sotto_imballi={selectedArticolo?.sotto_imballi}
              disponibilita={articolo.disponibilita}
              disponibilita_reale_maggiore={articolo.disponibilita_reale_maggiore}
              disponibilita_in_opzione={articolo.disponibilita_in_opzione}
              data_in_opzione={articolo.data_in_opzione}
              codice={articolo?.codice}
              prossimi_arrivi={articolo.prossimi_arrivi}
              onChangeInputQuantita={onChangeInputQuantita}
              handleQuantita={handleQuantita}
              OnClickRichiedi={OnClickRichiedi}
              service_gift={service_gift}
            ></DatatableRowProdotto>
          ))}
        </div>
      </Datatable>
      {showRiepilogo(utente, service_gift, isAs400Down) && (
        <div className="tableschedaprodotto__buttons">
          {(!service_gift || service_gift.personalizzazione) && isPersonalizzabile && (
            <Button
              disabled={
                quantita?.filter(
                  (item) => item?.escludi_da_listino_di_stampa === true && item?.quantita > 0
                )?.length > 0
                  ? true
                  : disabled
              }
              icon={<Customize />}
              icon_pos="left"
              size="medium"
              label={t('Personalizza tutti')}
              variant="secondary"
              onClick={() => {
                // ! funzione che calcola la quantità minima personalizzabile se è soddisfatta
                if (prodotto?.personalizzabile) {
                  const valore = quantita
                    ? quantita
                        ?.filter((item) => item?.escludi_da_listino_di_stampa !== true)
                        ?.reduce((previus, current, _) => previus + current.quantita, 0)
                    : 0

                  if (
                    valore >= prodotto?.quantita_minima_personalizzabile ||
                    getIgnoraMinimiStampa(utente, service_gift)
                  ) {
                    CheckPersonalizzazione(prodotto)
                  } else {
                    setShowQuantitaInsufficiente(true)
                  }
                } else {
                  setShowPersonalizzaForm(true)
                }
              }}
            />
          )}{' '}
          <Button
            disabled={!isValid()}
            icon={<Clipboard />}
            icon_pos="left"
            size="medium"
            label={
              service_gift && !service_gift.personalizzazione
                ? t('Aggiungi')
                : t('Aggiungi Senza Stampa')
            }
            variant="primary"
            onClick={() => _handleSubmit()}
          />
          <QuantitaInsufficientiModal
            isVisible={showQuantitaInsufficiente}
            setVisible={setShowQuantitaInsufficiente}
            quantita_minima_personalizzabile={prodotto?.quantita_minima_personalizzabile}
          />
          <QuantitaEccessivaModal
            isVisible={showQuantitaEccessiva}
            setVisible={setShowQuantitaEccessiva}
            quantita_massima_personalizzabile={quantitaMassimaPersonalizzabile}
          />
          <DuplicaPersonalizzazioneModal
            personalizzazioniDisponibili={personalizzazioniDisponibili}
            setShowPersonalizzaForm={setShowPersonalizzaForm}
            isVisible={showDuplicaPersonalizzazione}
            setVisible={setShowDuplicaPersonalizzazione}
            AddToCart={AddToCart}
            prodotto={prodotto}
          />
        </div>
      )}
    </>
  )
}

const DuplicaPersonalizzazioneModal = ({
  personalizzazioniDisponibili,
  setShowPersonalizzaForm,
  isVisible,
  setVisible,
  AddToCart,
  prodotto,
}) => {
  const t = useTrans()

  const [selected, setSelected] = useState(null)
  const [step, setStep] = useState(0)
  const [posizione, setPosizione] = useState()

  useEffect(() => {
    setStep(0)

    return () => {
      setStep(0)
    }
  }, [])

  const handleNome = (obj) => {
    const nome = obj?.toString().split('_')
    const numero_max = personalizzazioniDisponibili
      ?.filter((item) => item?.nome_lavorazione?.split('_')[0] === nome[0])
      ?.reduce(
        (prev, curr) => {
          const value = curr?.nome_lavorazione?.split('_')[1] || 0
          return Math.max(prev, parseInt(value))
        },
        [0]
      )
    const new_nome = nome[0] + '_' + (parseInt(numero_max) + 1)
    return new_nome
  }

  const handleSubmit = () => {
    const createNew = selected?.posizioni?.length > 1 && posizione < 2 ? true : false
    const Personalizzazione = { ...selected }
    const PersonalizzazioneSelezionata = createNew ? selected?.posizioni[posizione] : undefined
    const PersonalizzazioneModificata = createNew
      ? _.set(Personalizzazione, 'posizioni', [PersonalizzazioneSelezionata])
      : undefined

    const nome = handleNome(
      PersonalizzazioneModificata?.nome_lavorazione
        ? PersonalizzazioneModificata?.nome_lavorazione
        : selected?.nome_lavorazione
    )
    const params = PersonalizzazioneModificata
      ? {
          nome_lavorazione: nome,
          riconfezionamento: PersonalizzazioneModificata?.riconfezionamento,
          posizioni: PersonalizzazioneModificata?.posizioni?.map((posizione) => ({
            ...posizione,
            logo_file_id: posizione?.logo_file,
          })),
          stesso_logo: true,
        }
      : undefined
    createNew
      ? api
          .post(`${PERSONALIZZAZIONICARRELLO}`, params)
          .then((response) => {
            console.log(params)
            AddToCart(null, response.data.id)
            setStep(0)
            setVisible(false)
          })
          .catch((err) => setVisible(false))
      : (AddToCart(null, selected?.id), setStep(0), setVisible(false))
  }
  return (
    <NewModal
      visible={isVisible}
      title={t('Desideri duplicare la personalizzazione?')}
      text={t(
        'Le seguenti personalizzazioni salvate possono essere applicate alle referenze da te selezionate'
      )}
      actions={[
        <Button
          label={step > 0 ? t('Indietro') : t('Crea nuova personalizzazione')}
          variant="secondary"
          size="medium"
          onClick={() => {
            if (step === 0) {
              setShowPersonalizzaForm(true)
              setVisible(false)
              const first_articolo = prodotto?.articoli.length > 0 ? prodotto?.articoli[0] : null
              trackingGAEventProdotto(
                'duplicate_customization',
                'nessun_posizione',
                'crea_nuova',
                first_articolo?.titolo || '',
                prodotto?.codice || ''
              )
            } else {
              setStep(0)
              setPosizione(null)
            }
          }}
        />,
        <Button
          label={step > 0 ? t('Duplica Personalizzazione') : t('Procedi')}
          variant="primary"
          disabled={
            step === 0 ? (selected === null ? true : false) : posizione === null ? true : false
          }
          size="medium"
          onClick={() => {
            if (step === 0) setStep(1)
            else {
              const first_articolo = prodotto?.articoli.length > 0 ? prodotto?.articoli[0] : null
              let pos = ''
              if (posizione === 0) pos = 'posizione_1'
              else if (posizione === 1) pos = 'posizione_2'
              else if (posizione === 2) pos = 'entrambe'
              trackingGAEventProdotto(
                'duplicate_customization',
                pos,
                'applica',
                first_articolo?.titolo || '',
                prodotto?.codice || ''
              )
              handleSubmit()
            }
          }}
        />,
      ]}
    >
      {step === 0 ? (
        <div
          style={{ margintop: 20, maxHeight: 450, overflowY: 'scroll', textAlign: 'left' }}
          className="u-scrollable"
        >
          {personalizzazioniDisponibili?.map((item) => (
            <div style={{ margin: '5px 0px' }} key={`duplica-personalizzazione-${item?.id}`}>
              <FormRadio
                key={item?.id}
                label={item?.nome_lavorazione}
                checked={selected?.id === item?.id}
                onClick={() => setSelected(item)}
              />
            </div>
          ))}
        </div>
      ) : (
        <div style={{ margintop: 20, textAlign: 'left' }}>
          <p style={{ textTransform: 'uppercase', marginBottom: 10, color: '' }}>
            <strong>
              {t('Applica')} {selected?.nome_lavorazione}
            </strong>
          </p>
          <FormRadio
            checked={posizione === 0}
            label={t('A Posizione 1')}
            onClick={() => setPosizione(0)}
          />
          {selected?.posizioni?.length > 1 && (
            <>
              <FormRadio
                checked={posizione === 1}
                label={t('A Posizione 2')}
                onClick={() => setPosizione(1)}
              />
              <FormRadio
                checked={posizione === 2}
                label={t('A entrambe le posizioni')}
                onClick={() => setPosizione(2)}
              />
            </>
          )}
        </div>
      )}
    </NewModal>
  )
}

const QuantitaInsufficientiModal = ({
  isVisible,
  setVisible,
  quantita_minima_personalizzabile,
}) => {
  const t = useTrans()
  return (
    <NewModal
      visible={isVisible}
      alert={true}
      title={t('La quantità inserita non è sufficiente per la personalizzazione')}
      text={t(
        'Ti invitiamo ad aggiornare il numero degli articoli da personalizzare in modo da poter soddisfare \
        la quantità minima personalizzabile\
      '
      )}
      actions={[
        <Button
          label={t('Modifica quantità')}
          variant="primary"
          size="medium"
          onClick={() => setVisible(false)}
        />,
      ]}
    >
      <div className="quantitainsufficiente">
        <span className="quantitainsufficiente__label">
          {t('Quantità minima personalizzabile:')}
        </span>{' '}
        <span className="quantitainsufficiente__value">{quantita_minima_personalizzabile}</span>
      </div>
    </NewModal>
  )
}

const QuantitaEccessivaModal = ({ isVisible, setVisible, quantita_massima_personalizzabile }) => {
  const t = useTrans()
  return (
    <NewModal
      visible={isVisible}
      alert={true}
      title={t('La quantità inserita è troppo elevata per la personalizzazione')}
      text={t(
        "Se desideri personalizzare una quantità maggiore di {0} pz, contatta l'ufficio commerciale così che possa studiare una proposta mirata e verificare i tempi di consegna",
        [quantita_massima_personalizzabile]
      )}
      actions={[
        <Button
          label={t('Modifica quantità')}
          variant="primary"
          size="medium"
          onClick={() => setVisible(false)}
        />,
      ]}
    ></NewModal>
  )
}

export default TableSchedaProdotto

export const cols = {
  codice: { label: <Trans chiave="Codice" />, grow: 2, mobileCols: 4 },
  colore: { label: <Trans chiave="Colore" />, mobileCols: 4 },
  inchiostro: { label: <Trans chiave="Inchiostro" />, mobileCols: 2, grow: 2 },
  taglia: { label: <Trans chiave="Taglia" />, mobileCols: 4 },
  prezzo: { label: <Trans chiave="Prezzo" />, mobileCols: 6, mobileOrder: 'end' },
  disponibilita: {
    label: <Trans chiave="Disponibilità" />,
    info: (
      <Trans chiave="Disponibilità attuale dei prodotti e visualizzazione dei prossimi arrivi" />
    ),
    mobileCols: 6,
    grow: 2,
  },
  prossimi_arrivi: {
    label: <Trans chiave="Prossimi arrivi" />,
    info: (
      <Trans chiave="Nel caso di non disponibilità dell' articolo, è possibile ordinarlo su un prossimo arrivo (le date indicate sono valide solo se di colore verde)" />
    ),
    mobileCols: 6,
    grow: 2,
  },
  quantita: { label: <Trans chiave="Quantità" />, mobileCols: 12, grow: 2, mobileOrder: 'end' },
}

export const colsMenoTaglia = {
  codice: { label: <Trans chiave="Codice" />, grow: 2, mobileCols: 4 },
  colore: { label: <Trans chiave="Colore" />, mobileCols: 4 },
  inchiostro: { label: <Trans chiave="Inchiostro" />, mobileCols: 2, grow: 2 },
  prezzo: { label: <Trans chiave="Prezzo" />, mobileCols: 6, mobileOrder: 'end' },
  disponibilita: {
    label: <Trans chiave="Disponibilità" />,
    info: (
      <Trans chiave="Disponibilità attuale dei prodotti e visualizzazione dei prossimi arrivi" />
    ),
    mobileCols: 6,
    grow: 2,
  },
  prossimi_arrivi: {
    label: <Trans chiave="Prossimi arrivi" />,
    info: (
      <Trans chiave="Nel caso di non disponibilità dell' articolo, è possibile ordinarlo su un prossimo arrivo (le date indicate sono valide solo se di colore verde)" />
    ),
    mobileCols: 6,
    grow: 2,
  },
  quantita: { label: <Trans chiave="Quantità" />, mobileCols: 12, grow: 2, mobileOrder: 'end' },
}
